import { create } from 'zustand'
import type { SchedulePrefill } from '@/features/schedules/lib/schedule-form'

interface ScheduleEditorState {
  open: boolean
  /** Existing schedule to edit; null = create. */
  scheduleId: string | null
  prefill: SchedulePrefill
  /** Bumped on every open so the form remounts with fresh state. */
  session: number
  show: (opts?: { scheduleId?: string | null; prefill?: SchedulePrefill }) => void
  close: () => void
}

/** Global schedule editor sheet, mounted once in the app layout (lists, calendar, campaigns, conflicts). */
export const useScheduleEditor = create<ScheduleEditorState>()((set) => ({
  open: false,
  scheduleId: null,
  prefill: {},
  session: 0,
  show: ({ scheduleId = null, prefill = {} } = {}) => set((s) => ({ open: true, scheduleId, prefill, session: s.session + 1 })),
  close: () => set({ open: false }),
}))
